import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1915.91828,737.475294 C1904.96299,703.931765 1873.90416,681.343529 1838.55357,681.343529 L1226.52534,681.343529 L1037.46181,99.2447059 L1037.46181,99.1317647 C1026.39357,65.5882353 995.33475,43 959.984162,43 C924.746515,43 893.57475,65.5882353 882.619456,99.2447059 L693.442985,681.343529 L81.4147498,681.343529 C46.0641616,681.343529 15.0053381,703.931765 4.05004394,737.475294 C-6.90525018,771.018824 4.84063217,807.611765 33.527691,828.505882 L528.77475,1188.33647 L339.598279,1770.54824 C328.642985,1804.20471 340.727691,1840.79765 369.41475,1861.46588 C383.645338,1871.74353 400.360632,1876.95297 417.075926,1876.95297 C433.79122,1876.95297 450.506515,1871.74353 464.850044,1861.35294 L959.984162,1501.63529 L1455.00534,1861.35294 C1483.57946,1882.13412 1522.0924,1882.13412 1550.66651,1861.46588 C1579.35357,1840.79765 1591.32534,1804.20471 1580.37004,1770.43529 L1391.19357,1188.33647 L1886.55357,828.505882 C1915.12769,807.611765 1926.98651,771.018824 1915.91828,737.475294",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconStarLine = /*#__PURE__*/function (_Component) {
  _inherits(IconStarLine, _Component);

  var _super = _createSuper(IconStarLine);

  function IconStarLine() {
    _classCallCheck(this, IconStarLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconStarLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconStar",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconStarLine.displayName = "IconStarLine";
  return IconStarLine;
}(Component);

IconStarLine.glyphName = 'star';
IconStarLine.variant = 'Line';
IconStarLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconStarLine;
export { IconStarLine };